import { BarChartIcon } from '@/components/bar-chart-icon'
import {
  findSalaryBucket,
  formatCompModel,
} from '@/modules/salary/common/utils'
import * as React from 'react'
import { useSalaryHistogram } from '@/modules/salary/histogram/use-salary-histogram'

export function MiniPercentileHistogram({
  totalIncome,
  compModel,
}: {
  totalIncome: number
  compModel: string
}) {
  const { data } = useSalaryHistogram()
  const histogram = data?.getHistogram?.histogram
  const salaryBucket = findSalaryBucket(totalIncome, histogram)

  return (
    <div className="text-sm mb-2 flex justify-between text-copy-accent">
      <span>Comp Model ({formatCompModel(compModel)})</span>

      {salaryBucket?.label ? (
        <div className="flex items-center gap-1">
          <BarChartIcon highlightedBar={salaryBucket.percentileRangeIndex} />
          <span className="font-medium">{salaryBucket.label}</span>
        </div>
      ) : null}
    </div>
  )
}
